// Wire values for the Settlement tab (seller-service `/properties/:id/settlement`,
// enums copied from broker-db-service). Typed here so a backend rename breaks
// the type-check rather than silently mis-wording a status.

// The maker-checker lifecycle of an offering's settlement.
export const SETTLEMENT_STATUS = {
  notReady: 'not_ready',
  readyForSettlement: 'ready_for_settlement',
  draft: 'draft',
  awaitingApproval: 'awaiting_approval',
  approved: 'approved',
  partiallySettled: 'partially_settled',
  settled: 'settled',
} as const

// One owner's payout line within a settlement.
export const OWNER_LINE_STATUS = {
  blockedBankNotVerified: 'blocked_bank_not_verified',
  ready: 'ready',
  paid: 'paid',
  returned: 'returned',
} as const

// A recorded transfer against an owner line. `superseded` never reaches the
// portal — the server only sends the transfer still standing.
export const SETTLEMENT_PAYMENT_STATUS = {
  paid: 'paid',
  returned: 'returned',
} as const

// `property_owner_bank_accounts.bank_account_status`.
export const PAYOUT_BANK_STATUS = {
  pending: 'pending',
  verified: 'verified',
  rejected: 'rejected',
} as const

export const PAYOUT_BANK_STATUS_LABEL: Record<string, string> = {
  [PAYOUT_BANK_STATUS.pending]: 'Not verified',
  [PAYOUT_BANK_STATUS.verified]: 'Verified',
  [PAYOUT_BANK_STATUS.rejected]: 'Rejected',
}

// What the design prints in place of a figure that does not exist yet.
export const SETTLEMENT_EMPTY_VALUE = '—'

// The design masks every account to its last four characters.
export const MASKED_ACCOUNT_VISIBLE_DIGITS = 4
export const MASKED_ACCOUNT_PREFIX = '••••'
